import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  forwardRef,
  HostBinding,
  InjectionToken,
  Input,
  Provider,
  QueryList,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { clsx } from 'clsx';

import { RadioBadgeComponent } from '../radio-badge/radio-badge.component';
import { RadioBaseGroupDirective } from './radio-base-group.directive';

const CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioBadgeGroupComponent),
  multi: true,
};

export const SB_RADIO_BADGE_GROUP = new InjectionToken<RadioBadgeGroupComponent>('SbRadioBadgeGroup');

type Orientation = 'horizontal' | 'vertical';

@Component({
  selector: 'sb-radio-badge-group',
  standalone: true,
  imports: [CommonModule],
  exportAs: 'sbRadioBadgeGroup',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CONTROL_VALUE_ACCESSOR, { provide: SB_RADIO_BADGE_GROUP, useExisting: RadioBadgeGroupComponent }],
})
export class RadioBadgeGroupComponent extends RadioBaseGroupDirective {
  @ContentChildren(forwardRef(() => RadioBadgeComponent), { descendants: true })
  override radios!: QueryList<RadioBadgeComponent>;

  @Input()
  set orientation(value: Orientation) {
    this._orientation = value || 'horizontal';
    this.baseClass = this.getHostClasses();
  }
  get orientation(): Orientation {
    return this._orientation || 'horizontal';
  }
  private _orientation: Orientation = 'horizontal';

  @HostBinding('class')
  baseClass = this.getHostClasses();

  private getHostClasses(): string {
    return clsx('flex flex-wrap gap-2', this.orientation === 'horizontal' ? 'flex-row' : 'flex-col');
  }
}
